import { API_BASE_URLS } from '@/constants';

import { createApiClient } from './apiClient';

const coreApiService = createApiClient({
  baseURL: API_BASE_URLS.BASE_URL,
});

export const apiServices = { coreApiService };
